import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    users: [],
    granting: {},
    allGrants: {},
    allGrantsLoaded: false,
    editUser: null,
    userSetting: {},
    userSettingLoaded: false,
    group: { loaded: false }
};

const getUsersSuccess = (state, action) => {
    let users = Object.keys(action.payload.users).map(i => { return {
        ...action.payload.users[i].data,
        email: action.payload.users[i].email,
        first_name: action.payload.users[i].first_name,
        last_name: action.payload.users[i].last_name,
        lastactivity: action.payload.users[i].lastactivity,
        role: (action.payload.users[i].custom_permissions && action.payload.users[i].custom_permissions.MW) ? action.payload.users[i].custom_permissions.MW.role:'NA',
        metadata: action.payload.users[i].data.metadata.fields || {}
    }});
    return updateObject(state, { users: users});
}

const adminSetGranting = (state, action) => {
    return updateObject(state, { granting: action.payload.granting });
}

const adminSaveUserSuccess = (state, action) => {
    let updatedUsers = state.users.filter((e) => {

        return e.id != action.payload.user.id
    });
    updatedUsers.unshift({...action.payload.user});
    return updateObject(state, { editUser: null, users: updatedUsers});
}
const adminSaveNewUserSuccess = (state, action) => {
    let updatedUsers = state.users.slice();
    updatedUsers.unshift({...action.payload.user});
    return updateObject(state, { editUser: null, users: updatedUsers });
}

const getAllGrantsStart = (state) => {
    return updateObject(state, { allGrants: {}, allGrantsLoaded: false });
}

const getAllGrantsFail = (state) => {
    return updateObject(state, { allGrants: {}, allGrantsLoaded: false });
}

const setAllGrants = (state, action) => {
    return updateObject(state, { allGrants: action.payload.grants.elements, allGrantsLoaded: true });
}

const adminDeleteUserSuccess = (state, action) => {
    let modUsers = state.users.filter(u => u.id != action.payload.user);
    return updateObject(state,{ users: modUsers});
}

const adminSetEditUser = (state, action) => {
    return updateObject(state, {editUser: action.payload.user});
}

const loadGroupStart = (state, action) => {
    let group = { ...state.group, loaded: false };
    return updateObject(state, { group: group });
}

const loadGroupSuccess = (state, action) => {
    let group = { loaded: true, id: action.id, setting: { ...action.setting } };
    return updateObject(state, { group: group });
}

const loadGroupFail = (state, action) => {
    let group = { loaded: true, id: 0, setting: {} };
    return updateObject(state, { group: group });
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADMIN_GET_USERS_SUCCESS: return getUsersSuccess(state, action);
        case actionTypes.ADMIN_SET_GRANTING: return adminSetGranting(state, action);
        case actionTypes.ADMIN_SAVE_USER_SUCCESS: return adminSaveUserSuccess(state, action);
        case actionTypes.ADMIN_GET_ALL_GRANTS_START: return getAllGrantsStart(state, action);
        case actionTypes.ADMIN_SET_ALL_GRANTS: return setAllGrants(state, action);
        case actionTypes.ADMIN_GET_ALL_GRANTS_FAIL: return getAllGrantsFail(state, action);
        case actionTypes.ADMIN_SAVE_NEW_USER_SUCCESS: return adminSaveNewUserSuccess(state, action);
        case actionTypes.ADMIN_DELETE_USER_SUCCESS: return adminDeleteUserSuccess(state, action);
        case actionTypes.ADMIN_SET_EDITUSER: return adminSetEditUser(state, action);
        case actionTypes.ADMIN_LOAD_USER_SETTING_START: 
            return updateObject(state, { userSettingLoaded: false });
        case actionTypes.ADMIN_LOAD_USER_SETTING_SUCCESS: 
            return updateObject(state, { userSetting: action.setting, userSettingLoaded: true });
        case actionTypes.ADMIN_LOAD_USER_SETTING_FAIL: 
            return updateObject(state, { userSettingLoaded: true });
        case actionTypes.ADMIN_LOAD_GROUP_SETTING_START: return loadGroupStart(state, action);
        case actionTypes.ADMIN_LOAD_GROUP_SETTING_SUCCESS: return loadGroupSuccess(state, action);
        case actionTypes.ADMIN_LOAD_GROUP_SETTING_FAIL: return loadGroupFail(state, action);
        default: 
            return state;
    }
}

export default reducer;
